/**
 * 水平移动
 */
import fvAnimation from './fvAnimation';

export default class fvHorMove extends fvAnimation {
    constructor (shape) {
        super(shape, 'fvHorMove');
        this.sizeFunction = AsyncFunction('return ' + this.expression);
        this.bottomLeft = AsyncFunction('return ' + this.bottomLeft);
        this.topRight = AsyncFunction('return ' + this.topRight);
        this.bottomLeftMove = AsyncFunction('return ' + this.bottomLeftMove);
        this.topRightMove = AsyncFunction('return ' + this.topRightMove);
        this.x = shape.x;
        this.originalSizeX = shape.originalSize.x;
        for (let p in this.shape.subObjects) {
            if (this.shape.subObjects[p] && this.shape.subObjects[p].$) {
                this.shape.subObjects[p].x = this.shape.subObjects[p].$.x;
            }
        }
    }

    async run (canvas, value) {
        if (value == false) return;
        let size = await this.executionScript(this.sizeFunction);
        let bottomLeftValue = await this.executionScript(this.bottomLeft);
        let topRightValue = await this.executionScript(this.topRight);
        let bottomLeftMoveValue = await this.executionScript(this.bottomLeftMove);
        let topRightMoveValue = await this.executionScript(this.topRightMove);
        let viewNum = (parseFloat(topRightMoveValue) - parseFloat(bottomLeftMoveValue)) * (size - parseFloat(bottomLeftValue)) / (parseFloat(topRightValue) - parseFloat(bottomLeftValue)) + parseFloat(bottomLeftMoveValue);
        // 点不存在不移动
        if (size === -9999) return;
        if (size <= bottomLeftValue || size <= topRightValue) {
            if (bottomLeftMoveValue < topRightMoveValue) {
                this.shape.translateX = viewNum;
            } else if (bottomLeftMoveValue == topRightMoveValue) {
                this.shape.translateX = viewNum;
            } else {
                this.shape.translateX = 0 - viewNum;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvHorMove.js